module.exports = __webpack_public_path__ + "img/avenging_spirit_small.8c63d946.png";